import { render, staticRenderFns } from "./bulkassigned.vue?vue&type=template&id=ebd5536a&"
import script from "./bulkassigned.vue?vue&type=script&lang=js&"
export * from "./bulkassigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports